export default __webpack_public_path__ + "static/media/T02.6b383b87.png";